import React from 'react';
import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import RestartAltRoundedIcon from '@mui/icons-material/RestartAltRounded';
import { alpha, useTheme } from '@mui/material/styles';

export default function FilterBar({
  left,
  right,
  dense = false,
  sticky = false,
  onReset,
  resetLabel = 'Reset filters',
  sx,
}) {
  const theme = useTheme();

  return (
    <Box
      sx={[
        {
          p: dense ? 1 : 1.25,
          borderRadius: 2.5,
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor:
            theme.palette.mode === 'dark'
              ? alpha(theme.palette.background.paper, 0.75)
              : alpha(theme.palette.background.paper, 0.9),
          backdropFilter: 'blur(8px)',
          ...(sticky
            ? {
                position: 'sticky',
                top: 76,
                zIndex: 4,
              }
            : null),
        },
        sx,
      ]}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={1}
        alignItems={{ md: 'center' }}
        justifyContent="space-between"
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1}
          sx={{ width: '100%' }}
          alignItems={{ sm: 'center' }}
        >
          {left}
        </Stack>

        <Stack direction="row" spacing={0.75} alignItems="center">
          {right}
          {onReset ? (
            <Tooltip title={resetLabel}>
              <IconButton size="small" onClick={onReset} aria-label={resetLabel}>
                <RestartAltRoundedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          ) : null}
        </Stack>
      </Stack>
    </Box>
  );
}

